import { round3 } from './pricing';
import type { DeliverySettings } from './types';

/**
 * Calcule les frais de livraison pour une commande.
 *
 * Règles (Tunielec) :
 *  - Frais fixes par défaut (7 TND, configurable via tenant settings).
 *  - Si `freeFrom` est défini et le sous-total TTC dépasse ce seuil,
 *    livraison gratuite.
 *  - Devis : toujours 0 (pas de livraison sur un devis).
 */
export function computeDeliveryFee(
  subtotalTtc: number,
  settings: DeliverySettings,
): number {
  if (settings.freeFrom && subtotalTtc >= settings.freeFrom) return 0;
  return round3(Math.max(0, settings.fee ?? 0));
}

export const DEFAULT_DELIVERY_SETTINGS: DeliverySettings = {
  fee: 7,
  freeFrom: null,
};
